import { useMemo, useRef, useEffect } from 'react';
import { useInView } from '../hooks/useInView.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import { SelectInput } from '../ui/Select/SelectInput.js';
import { scrollToAnchor } from '../utils/scrollToAnchor.js';
import { jsx } from 'react/jsx-runtime';
function EditorialArticleNavigationSelect({
  quickScrollContent = [],
  children
}) {
  const anchors = useMemo(() => quickScrollContent?.map(q => q.anchor), [quickScrollContent]);
  const anchorIndexInView = useInView(anchors, 20);
  const selectRef = useRef();
  const scrollInMotionToRef = useRef(null);
  const selectOptions = useMemo(() => quickScrollContent.map(opt => ({
    value: opt.anchor,
    label: opt.text
  })), [quickScrollContent]);
  useEffect(() => {
    if (anchorIndexInView !== -1) {
      if (scrollInMotionToRef.current) {
        if (selectOptions[anchorIndexInView].value === scrollInMotionToRef.current) scrollInMotionToRef.current = null;
      } else {
        selectRef.current?.setSelectValue(selectOptions[anchorIndexInView]);
      }
    }
  }, [anchorIndexInView, selectOptions]);

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const onSelectChange = nextValue => {
    scrollInMotionToRef.current = nextValue;
    scrollToAnchor(nextValue, 180);
  };
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "EditorialArticleNavigationSelect",
      children: /*#__PURE__*/jsx(SelectInput, {
        onChange: onSelectChange,
        label: "",
        optionValues: selectOptions,
        selectRef: selectRef,
        children: children
      })
    })
  });
}
export { EditorialArticleNavigationSelect };
//# sourceMappingURL=EditorialArticleNavigationSelect.js.map
